<template>
    <div>
        <div class="row  no-gutters pt-xl-4 mb-xl-6">
            <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
                 v-if="lesson">
                {{lesson.lesson}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points && testmode==0">
                <div class="zerno-points">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1">{{ $t('test') }} {{$t('№')}}{{ test.pos }}
                    <span class="ml-2" v-if="testsCount > 0">({{test.pos}} {{$t('of')}} {{testsCount}})</span>
                </div>
            </div>

            <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

                <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
                <h2 class="mt-7" v-else>{{ $t('test') }} {{$t('№')}}{{ test.pos }}</h2>
                <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
                <button
                        class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                        @click="startTest">
                    <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{$t('№')}}{{ test.pos }}
                </button>

            </div>

            <div class="col-12 order-10 text-center" v-if="!showTestIntro && test">


                <img :src="mainElement.image" class="my-3 test-image single-image" height="300"/>
                <div class="">
                    <div class="row justify-content-center">
                        <div class="d-flex justify-center mb-6 col-auto flex-wrap align-items-center justify-content-center">
                            <div v-for="(item, i) in letters"
                                 :key="i"
                                 :raised="item.color!=='red'"
                                 :color="item.color"
                                 class="ma-3 display-4 font-weight-bold btn btn-secondary btn-letter letter-btn"
                                 v-text="item.content"/>
                        </div>
                    </div>

                    <div class="row">
                        <div
                                class="mt-2 pa-0 col-12"
                        >
                            <button
                                    v-for="(item, i) in keyboardRow1"
                                    :key="i"
                                    :class="['btn btn-info btn-key mx-1 mb-xl-0 mb-2 display-2 text-center pa-0 keyboard-btn', item.color?item.color:'btn-info']"
                                    @click="keyClick(item)"
                            >
                                {{ item.letter }}
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div
                                class="mt-1 pa-0 col-12"
                        >
                            <button
                                    v-for="(item, i) in keyboardRow2"
                                    :key="i"
                                    :class="['btn btn-info btn-key mx-1 mb-xl-0 mb-2 display-2 text-center pa-0 keyboard-btn', item.color?item.color:'btn-info']"
                                    @click="keyClick(item)"
                            >
                                {{ item.letter }}
                            </button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="mt-1 pa-0 col-12">
                            <button
                                    v-for="(item, i) in keyboardRow3"
                                    :key="i"
                                    :class="['btn btn-info btn-key mx-1 mb-xl-0 mb-2 display-2 text-center pa-0 keyboard-btn', item.color?item.color:'btn-info']"
                                    @click="keyClick(item)"
                            >
                                {{ item.letter }}
                            </button>
                            <button class="d-none d-xl-inline-block btn btn-info btn-key mx-1 display-2"
                                    style="visibility:hidden; width: 70px; height: 70px;"></button>
                        </div>
                    </div>
                </div>
            </div>


        </div>
        <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
            <button
                    class="btn btn-info"
                    @click="skip"
            >
                {{ $t('omit_task') }} &rarr;
            </button>
        </div>
    </div>


</template>
<style>
@media (min-width: 1024.1px) {
  .keyboard-btn {
    width: 70px;
    height: 70px;
    line-height: 35px;
    font-size: 35px;
  }

  .letter-btn {
    width: 70px;
    height: 70px;
    line-height: 50px;
    font-size: 40px;
  }
}
@media (max-width: 1024px) {
  .keyboard-btn {
    width: 28px;
    height: 28px;
    line-height: 28px;
    font-size: 22px;
    padding: 0;
  }

  .letter-btn {
    width: 35px;
    height: 35px;
    line-height: 35px;
    font-size: 22px;
    padding: 0;
  }
}


</style>

<script>
    import Vue from 'vue'
    import api from '@/utils/api'

    export default {
        name: 'Test17',
        props: {
            idtest: {default: null},
            lesson: {type: Object, default: null},
            points: {default: null},
            testsCount: {default: null},
            showButtons: {type: Boolean, default: true},
            testmode: {default: 0},
        },
        data: () => ({
            test: {},
            testtasks: [],
            testelements: [],
            taskIdx: 0,
            audio: new Audio(),
            errorCount: 0,

            forceRenderKey: 0,

            keyboardRow1: [],
            keyboardRow2: [],
            keyboardRow3: [],

            keyboardEnRow1: [{letter: 'Q', color: 'blue'}, {letter: 'W', color: 'blue'}, {letter: 'E', color: 'blue'}, {letter: 'R', color: 'blue'}, {letter: 'T', color: 'blue'}, {letter: 'Y', color: 'blue'}, {letter: 'U', color: 'blue'}, {letter: 'I', color: 'blue'}, {letter: 'O', color: 'blue'}, {letter: 'P', color: 'blue'}],
            keyboardEnRow2: [{letter: 'A', color: 'blue'}, {letter: 'S', color: 'blue'}, {letter: 'D',color: 'blue'}, {letter: 'F', color: 'blue'}, {letter: 'G', color: 'blue'}, {letter: 'H', color: 'blue'}, {letter: 'J', color: 'blue'}, {letter: 'K', color: 'blue'}, {letter: 'L', color: 'blue'}],
            keyboardEnRow3: [{letter: 'Z', color: 'blue'}, {letter: 'X', color: 'blue'}, {letter: 'C', color: 'blue'}, {letter: 'V', color: 'blue'}, {letter: 'B', color: 'blue'}, {letter: 'N', color: 'blue'}, {letter: 'M', color: 'blue'}],

            keyboardRuRow1: [{letter: 'Й', color: 'blue'},{letter: 'Ц', color: 'blue'},{letter: 'У', color: 'blue'},{letter: 'К', color: 'blue'},{letter: 'Е', color: 'blue'},{letter: 'Н', color: 'blue'},{letter: 'Г', color: 'blue'},{letter: 'Ш', color: 'blue'},{letter: 'Щ', color: 'blue'},{letter: 'З', color: 'blue'},{letter: 'Х', color: 'blue'},{letter: 'Ъ', color: 'blue'}],
            keyboardRuRow2: [{letter: 'Ф', color: 'blue'},{letter: 'Ы', color: 'blue'},{letter: 'В', color: 'blue'},{letter: 'А', color: 'blue'},{letter: 'П', color: 'blue'},{letter: 'Р', color: 'blue'},{letter: 'О', color: 'blue'},{letter: 'Л', color: 'blue'},{letter: 'Д', color: 'blue'},{letter: 'Ж', color: 'blue'},{letter: 'Э', color: 'blue'}],
            keyboardRuRow3: [{letter: 'Я', color: 'blue'},{letter: 'Ч', color: 'blue'},{letter: 'С', color: 'blue'},{letter: 'М', color: 'blue'},{letter: 'И', color: 'blue'},{letter: 'Т', color: 'blue'},{letter: 'Ь', color: 'blue'},{letter: 'Б', color: 'blue'},{letter: 'Ю', color: 'blue'}],

            letters: [],

            showTestIntro: true,
            //errorChord: 'gong.mp3',
            errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
            okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',
        }),

        computed: {
            currentTask: function () {
                console.log('currentTask')
                return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
            },

            mainElement: function () {
                console.log('mainElement', this.getBy('ismain', 1, this.testelements))
                if (!this.testelements.length) return {}
                const main = this.getBy('ismain', 1, this.testelements)
                return main.ismain ? main : this.testelements[0]
            },

            answers: function () {
                console.log('answers')
                return this.testelements.filter(function (e) {
                    return !e.ismain
                })
            },
        },

        watch: {
            taskIdx: async function () {
                this.loadTask()
            },
        },

        async mounted() {
            api({url: '/tests/' + this.idtest}).then(resp => {
                this.test = resp.data
            })
            const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
            this.testtasks = response.data
            this.loading = false

        },
        methods: {
            async startTest() {
                if (this.testtasks.length) {
                    if (this.test.audio) {
                        await this.play(this.test.audio)
                    }
                    this.showTestIntro = false
                    this.loadTask()
                }
            },
            async loadTask() {
                if (this.currentTask.idtesttask) {
                    const response = await api({
                        method: 'get',
                        url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
                    })
                    this.testelements = response.data
                    const word2 = this.mainElement.word2.match(/.{1,1}/g)
                    this.letters = this.mainElement.word.match(/.{1,1}/g).map(e => ({ letter: e, content: '' }))

                    if (this.isCyrillic(this.mainElement.word)) {
                        this.keyboardRow1 = this.keyboardRuRow1
                        this.keyboardRow2 = this.keyboardRuRow2
                        this.keyboardRow3 = this.keyboardRuRow3
                    } else {
                        this.keyboardRow1 = this.keyboardEnRow1
                        this.keyboardRow2 = this.keyboardEnRow2
                        this.keyboardRow3 = this.keyboardEnRow3
                    }

                    for (let i = 0; i < this.letters.length && i < word2.length; i++) {
                        if (word2[i] !== '_') this.letters[i].content = this.letters[i].letter
                    }

                    this.clearButtons()
                    this.play(this.mainElement.audio)
                } else {
                    this.testelements = []
                    this.letters = []
                    this.clearButtons()
                    this.$emit('testComplete')
                }
            },
            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            isCyrillic (text) {
                return /[а-я]/i.test(text)
            },

            play: function (path) {
                return new Promise((resolve) => {
                    if (path) {
                        this.audio.src = path
                        this.audio.play()
                        this.audio.onended = function () {
                            console.log('Звук закончился')
                            resolve()
                        }

                        this.audio.onerror = function () {
                            console.log('Звук error')
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                })
            },

            async keyClick(button) {
                let search = true
                for (const i in this.letters) {
                    if (search && this.testmode == 1 && !this.letters[i].content) {
                        if (this.letters[i].letter.toUpperCase() !== button.letter.toUpperCase()) this.errorCount++
                        this.letters[i].content = button.letter.toLowerCase()
                        search = false
                    } else if (search && !this.letters[i].content && this.letters[i].letter.toUpperCase() === button.letter.toUpperCase()) {
                        this.letters[i].content = this.letters[i].letter
                        this.clearButtons()
                        await this.play(this.okChord)
                        search = false
                    } else if (search && !this.letters[i].content) {
                        Vue.set(button, 'color', 'btn-danger')
                        this.play(this.errorChord)
                        return
                    } else if (!this.letters[i].content) {
                        return
                    }
                }

                if (this.mainElement.audio) {
                    await this.play(this.mainElement.audio)
                } else {
                    await this.play(this.okChord)
                }

                if(this.testmode==0 || !this.errorCount) this.$emit('correctAnswer')
                else this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: `Неправильных попыток: ${this.errorCount}.`})
                this.taskIdx++

            },

            clearButtons() {
                for (const i in this.keyboardRow1) this.keyboardRow1[i].color = 'btn-info'
                for (const i in this.keyboardRow2) this.keyboardRow2[i].color = 'btn-info'
                for (const i in this.keyboardRow3) this.keyboardRow3[i].color = 'btn-info'
            },

            skip: function () {
                this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
                this.taskIdx++
            },

        },
    }
</script>
